var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureIconBedFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9347 13.8802H1.45577V14.7786C1.45577 14.7977 1.36334 14.994 1.34023 15.0296C0.997876 15.5625 0.172698 15.4136 0.019459 14.8038L0 9.25171C0.109456 8.17549 0.993619 7.30234 2.06811 7.24512H18.3674C19.42 7.3288 20.2464 8.16134 20.3856 9.21048C20.281 10.9605 20.5443 12.916 20.3929 14.642C20.3418 15.2241 19.7526 15.5638 19.2552 15.2364C19.1524 15.1687 18.9341 14.893 18.9341 14.778V13.8796L18.9347 13.8802Z",
    fill: "#183029"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2074 5.77386H16.0225V4.82933C16.0225 4.36107 15.4667 3.79743 15.0459 3.65282C14.5783 3.49284 12.9134 3.51991 12.3569 3.56052C11.747 3.60544 10.9249 4.15739 10.9249 4.82933V5.77386H9.46852V4.82933C9.46852 4.36107 8.91273 3.79743 8.49193 3.65282C8.02431 3.49284 6.35936 3.51991 5.80295 3.56052C5.19304 3.60544 4.3709 4.15739 4.3709 4.82933V5.77386H2.18604V1.19089C2.18604 1.00814 2.52961 0.650632 2.72967 0.635864L17.699 0.64694C17.8863 0.669092 18.208 1.02168 18.208 1.19089V5.77386H18.2074Z",
    fill: "#183029"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIconBedFilled);
export default __webpack_public_path__ + "static/media/feature-icon-bed-filled.8936cbd2.svg";
export { ForwardRef as ReactComponent };